import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/logo.png'; // Update the path if needed
import '../App.css'; // If your navbar styles are here

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header>
      <nav className="navbar">
        <a href="/" className="logo">
          <img src={logo} alt="Chaman Hospital" className="logo-img" />
        </a>
        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li><a href="/" className="active">Home</a></li>
          <li><a href="/Appointment">Appointment</a></li>
          <li><a href="/about">About</a></li>
          <li><a href="/services">Services</a></li>
          <li><a href="/doctors">Doctors</a></li>
          <li><a href="/contact">Contact</a></li>
          <li><a href="/login" className="btn-login">Login</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
